import React from 'react';
import { Navigate } from 'react-router-dom';

const renderComponent = (C, cProps) => {
  const directories = window.location.pathname.split('/');

  if (!cProps.is_authenticated) {
    const pathname = cProps.location.pathname;

    if (!pathname) {
      return <Navigate to="/admin" />;
    }
    const search = cProps.location.search;

    if (['/'].indexOf(pathname) > -1 || directories.length < 2) {
      return <Navigate to={`/admin?redirect=${pathname}${search}`} />;
    }

    return <Navigate to={`/login?redirect=${pathname}${search}`} />;
  }

  if (!directories[0]) {
    directories[0] = 'measurement-screen';
  }

  const isAdmin = cProps.is_admin;
  const isCustomUser = cProps.is_custom_user;
  const userName = cProps.user.username;
  if (!isAdmin && directories[1] === 'check-data') {
    return <Navigate to={`/${directories[0]}/${userName}`} />;
  }

  const siteId = directories[2];

  if (!isAdmin && !isCustomUser && (directories.length < 2 || siteId !== userName)) {
    return <Navigate to={`/${directories[0]}/${userName}`} />;
  }

  if (isCustomUser && directories.length === 3 && cProps.site_list) {
    const viewableSites = cProps.site_list.sites.map((s) => s.site);

    // 閲覧権限の無い現場をURLで直打ちされた場合を想定
    // topPageにリダイレクトする
    if (!viewableSites.includes(siteId)) {
      return <Navigate to={'/'} />;
    }
  }

  return <C {...cProps} />;
};

const authenticatedRoute = ({ component: C, props: cProps }) => {
  return renderComponent(C, cProps);
};

export default authenticatedRoute;
